import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';
import {
  HEADING_TRANSLATIONS,
  PortfolioSellerTableKeys,
  SORTING_VALUES,
  SortingValues,
} from '../components/SellerDealTableCells/data';
import {
  ASCENDING_DESCENDING_COPY,
  EARLIEST_LATEST_COPY,
  INITIAL_ADVANCED_COPY,
  SORTING_ORDER,
  SortingDirectionValues,
} from 'models/Sort';

const MULTI_SORT_COPY = {
  [SORTING_VALUES.filesSort]: 'numberOfFiles',
  [SORTING_VALUES.buyersSort]: 'numberOfLeads',
  [SORTING_VALUES.commission]: 'commission',
};

export const MULTI_SORT_DIRECTION_COPY = {
  [SORTING_VALUES.stage]: INITIAL_ADVANCED_COPY,
  [SORTING_VALUES.listingStage]: INITIAL_ADVANCED_COPY,
  [SORTING_VALUES.lastUpdated]: EARLIEST_LATEST_COPY,
  [SORTING_VALUES.price]: ASCENDING_DESCENDING_COPY,
  [SORTING_VALUES.commission]: ASCENDING_DESCENDING_COPY,
  [SORTING_VALUES.buyersSort]: ASCENDING_DESCENDING_COPY,
  [SORTING_VALUES.filesSort]: ASCENDING_DESCENDING_COPY,
};

const useSellingMultiSort = (
  tableColumns: Partial<PortfolioSellerTableKeys>,
) => {
  const { t } = useTranslation();

  const sortColumns = useMemo(
    () => tableColumns.filter((column) => !!SORTING_VALUES[column]),
    [tableColumns],
  );

  const multiSortValues = useMemo(
    () =>
      sortColumns.map((column) => {
        const value = SORTING_VALUES[column];
        const label = t(MULTI_SORT_COPY[value] || HEADING_TRANSLATIONS[column]);

        return {
          value,
          label,
        };
      }) as OptionValue<SortingValues>[],
    [sortColumns, t],
  );

  const multiSortDirectionTranslation = useMemo(() => {
    const result: SortingDirectionValues = {};

    for (const column of sortColumns) {
      const sort = SORTING_VALUES[column];
      const value = MULTI_SORT_DIRECTION_COPY[sort];

      result[sort] = {
        [SORTING_ORDER.A_TO_Z]: t(value?.[SORTING_ORDER.A_TO_Z] || 'aToZ'),
        [SORTING_ORDER.Z_TO_A]: t(value?.[SORTING_ORDER.Z_TO_A] || 'zToA'),
      };
    }

    return result;
  }, [sortColumns, t]);

  return { multiSortValues, multiSortDirectionTranslation };
};

export default useSellingMultiSort;
